module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "DEDICATION1"
  }, [_vm._v("Come you indoors, come home; your fading fire"), _c('br'), _vm._v("Mend first and vital candle in close heart’s vault.")]), _vm._v(" "), _c('p', {
    staticClass: "DEDICATION2"
  }, [_vm._v("Gerard Manley Hopkins, S.J."), _c('br'), _vm._v("“The Candle Indoors”")]), _vm._v(" "), _c('p', {
    staticClass: "DEDICATION3"
  }, [_vm._v("To the members of the"), _c('br'), _vm._v("Academy of Catholic Theology")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9838e502","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Oakes_A_Theology_of_Grace3.vue
// module id = 66
// module chunks = 0